import { useEffect } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { useNotificationStore } from '@/common';
import { axios } from '@/library/axios';
import type { BaseResponse } from '@/types';
import { displayError } from '@/utils/functions/displayError';

import type { AddAddressReq, AddAddressRes } from './types';

const addAddress = async ({
  customerId,
  address,
}: {
  customerId: string;
  address: AddAddressReq;
}) => {
  return axios<
    AddAddressRes,
    BaseResponse<AddAddressRes, AddAddressReq>,
    AddAddressReq
  >({
    url: `/customers/${customerId}/addresses`,
    method: 'post',
    data: address,
  });
};

export const useAddCustomerAddress = () => {
  const { addNotification } = useNotificationStore();
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading, error } = useMutation(addAddress, {
    onSuccess: () => {
      queryClient.invalidateQueries('customer-addresses');
      addNotification({
        title: 'Successfull',
        type: 'success',
        message: 'Address added successfully.',
      });
    },
  });

  useEffect(() => {
    displayError(error);
  }, [error]);

  return {
    addCustomerAddress: mutateAsync,
    isLoading,
  };
};
